import { useEffect, useRef } from 'react';
import useReveal from '@/shared/useReveal.js';
import useLocale from '@/shared/useLocale.js';
import AnimatedBackground from '@/shared/AnimatedBackground.jsx';
import SiteNav, { NAV_LABELS_EN, NAV_LABELS_VI } from '@/shared/SiteNav.jsx';
import LocaleToggle from '@/shared/LocaleToggle.jsx';
import '@/shared/styles/page-chrome.css';
import './landing.css';
import { LANDING_LOCALES, landingContent } from './landingContent.js';
import Hero from './sections/Hero.jsx';
import TrustStrip from './sections/TrustStrip.jsx';
import Features from './sections/Features.jsx';
import SecurityShowcase from './sections/SecurityShowcase.jsx';
import LiveDemo from './sections/LiveDemo.jsx';
import AIAssistant from './sections/AIAssistant.jsx';
import Tasks from './sections/Tasks.jsx';
import UseCases from './sections/UseCases.jsx';
import Partners from './sections/Partners.jsx';
import Download from './sections/Download.jsx';
import Footer from './sections/Footer.jsx';

export default function Landing() {
  const rootRef = useRef(null);
  useReveal(rootRef);
  const [locale, setLocale] = useLocale();
  const t = landingContent[locale];

  // index.html ships the English title for crawlers and the first paint; a
  // visitor reading in Vietnamese gets the Vietnamese one.
  useEffect(() => {
    document.title = t.meta.title;
  }, [t.meta.title]);

  return (
    <div className={`gc-root${locale === 'vi' ? ' gc-vi' : ''}`} ref={rootRef}>
      <AnimatedBackground />
      <div className="gc-shell">
        <SiteNav labels={locale === 'vi' ? NAV_LABELS_VI : NAV_LABELS_EN}>
          <LocaleToggle locale={locale} locales={LANDING_LOCALES} onChange={setLocale} />
        </SiteNav>
        <Hero t={t.hero} />
        <TrustStrip t={t.trust} />
        <Features t={t.features} />
        <SecurityShowcase t={t.security} />
        <LiveDemo t={t.demo} />
        <AIAssistant t={t.ai} />
        <Tasks t={t.tasks} />
        <UseCases t={t.useCases} />
        <Partners t={t.partners} />
        <Download t={t.download} />
        <Footer t={t.footer} />
      </div>
    </div>
  );
}
